import { saveUserSettings, setUserProfile, userSettings } from "@/globals/userSettings";
import runAccessibility from "./runAccessibility";
import toggleScreenReader from "./toggleScreenReader";

export default function reset() {
    const screenReaderEnabled = userSettings?.states?.['screen-reader']

    document?.querySelectorAll(".asw-selected")?.forEach(el => el?.classList?.remove("asw-selected"));
    setUserProfile('', {});
    runAccessibility();

    if(screenReaderEnabled) {
        toggleScreenReader(false);
    }
}